import React, { useState } from 'react'
import { Container, Typography, Grid2, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { IconMapPin, IconMail, IconBrandWhatsapp } from '@tabler/icons-react'
import { useForm } from 'react-hook-form'  
import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

import CustomButton from '@components/button/customButton'
import ControlledTextField from '@components/inputs/controlledTextField'
import InfoDialog from '@components/dialog/infoDialog'

import { useSnackbar } from '@context/snackbarContext'

import { UserApiEndpoints } from '@configuration/apiEndpoints'

import "./contactUs.css";

import QRWhatsApp from '@assets/image/contact-whatsapp.png'
import QRLine from '@assets/image/contact-line.png'
import QRWeChat from '@assets/image/contact-wechat.png'

export default function ContactUs() {
  const { t } = useTranslation()
  const openSnackbar = useSnackbar()

  const { handleSubmit, control, reset } = useForm({})

  const [openInfoDialog, setOpenInfoDialog] = useState(false)

  const createInquiryMutation = useMutation({
    mutationFn: (data) => {
      return axios.post(UserApiEndpoints.createInquiry, data, { requiresAuth: false })
    },
    onSuccess: () => {
      setOpenInfoDialog(true)
      reset()
    },
    onError: (err) => {
      openSnackbar(t('contact-page.inquiryFailed'), "error");
    }
  })

  const onSubmit = (data) => {
    createInquiryMutation.mutate(data)
  }
  
  return (
    <div className='contact-us-wrapper'>
    <Container className='contact-us'>
      <Paper className='information-card'>
        <Typography className='title'>{t('contact-page.contactInformation')}</Typography>
        <Typography className='description'>{t('contact-page.contactInformationDesc')}</Typography>
        <Typography className='name'>{t('contact-page.zhushan')}</Typography>
        <div className='point-warpper'>
          {/* <div className='point-inner'>
            <div style={{flexShrink: 1, display: 'flex',alignSelf: 'center'}}>
              <IconMapPin size={18} color='#7CA7AD'/>
            </div>
            <Typography className='point'>
              9, Jalan Kenari 13a, Bandar Puchong Jaya, 47170 Selangor
            </Typography>
          </div> */}
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <IconMail size={18} color="#7CA7AD" />
              <Typography className="point">
                zhushan.mychan@gmail.com
              </Typography>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <IconBrandWhatsapp size={18} color="#7CA7AD" />
              <Typography className="point">+60 17-204 3340</Typography>
            </div>
        </div>
        <Typography className='other'>{t('contact-page.contactOther')}</Typography>
        <Grid2 container spacing={'0px'} className='other-grid'>
          <Grid2 size={{lg: 3.5, md: 3.5,  sm: 3, xs: 4}}>
            <img src={QRWhatsApp} width={'100%'} alt='WhatsApp'/>
            <Typography fontSize={10} fontWeight={500} textAlign={'center'} marginTop={'-5px'}>
              WhatsApp
            </Typography>
          </Grid2>
          <Grid2 size={{lg: 3.5, md: 3.5,  sm: 3, xs: 4}}>
            <img src={QRLine} width={'100%'} alt='LINE'/>
            <Typography fontSize={10} fontWeight={500} textAlign={'center'} marginTop={'-5px'}>
              LINE
            </Typography>
          </Grid2>
          <Grid2 size={{lg: 3.5, md: 3.5,  sm: 3, xs: 4}}>
            <img src={QRWeChat} width={'100%'} alt='WeChat'/>
            <Typography fontSize={10} fontWeight={500} textAlign={'center'} marginTop={'-5px'}>
              WeChat
            </Typography>
          </Grid2>
        </Grid2>
      </Paper>
      <Paper className='contact-card'>
        <form onSubmit={handleSubmit(onSubmit)}>
        <Typography className='title'>{t('contact-page.contactUs')}</Typography>
        <Typography className='description'>{t('contact-page.contactUsDesc')}</Typography>
        <Grid2 container spacing={'25px'}>
          <Grid2 size={12}>
            <ControlledTextField 
              name="fullName"
              control={control}
              label={t('contact-page.fullName')}
              variant='standard'
              size='medium'
              rules={{
                required: t('contact-page.fullNameRequired')
              }}
              readOnly={createInquiryMutation.isPending}
            />
          </Grid2>
          <Grid2 size={{ lg: 6, md: 6,  sm: 8, xs: 12 }}>
            <ControlledTextField 
              name="emailAddress"
              control={control}
              label={t('contact-page.emailAddress')}
              variant='standard'
              size='medium'
              rules={{
                required: t('contact-page.emailAddressRequired'),
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: t('contact-page.emailAddressInvalid'),
                }
              }}
              readOnly={createInquiryMutation.isPending}
            />
          </Grid2>
          <Grid2 size={{ lg: 6, md: 6,  sm: 8, xs: 12 }}>
            <ControlledTextField 
              name="contactNumber"
              control={control}
              label={t('contact-page.contactNumber')}
              variant='standard'
              size='medium'
              rules={{
                required: t('contact-page.contactNumberRequired'),
                pattern: {
                  value: /^[0-9]+$/,
                  message: t('contact-page.contactNumberInvalid')
                }
              }}
              readOnly={createInquiryMutation.isPending}
            />
          </Grid2>
          <Grid2 size={12}>
            <ControlledTextField 
              name="message"
              control={control}
              label={t('contact-page.message')}
              variant='standard'
              size='medium'
              rules={{
                required: t('contact-page.messageRequired')
              }}
              multiline
              rows={5}
              readOnly={createInquiryMutation.isPending}
            />
          </Grid2>
          <Grid2 size={12} display={'flex'} justifyContent={'flex-end'}>
            <CustomButton type="submit" disabled={createInquiryMutation.isPending}>{t('contact-page.send')}</CustomButton>
          </Grid2>
        </Grid2>
        </form>
      </Paper>
    </Container>
    <InfoDialog
      open={openInfoDialog}
      onClose={()=>setOpenInfoDialog(false)}
      dialogTitle={t('contact-page.inquiryReceived')}
      dialogDescription={t('contact-page.inquiryReceivedDesc')}
      closeText={t('ok')}
    />
    </div>
  )
}
